import algoliasearch from 'algoliasearch/lite';

export function getSearchClient() {
    if (!process.env.VUE_APP_ALGOLIA_APP_ID || !process.env.VUE_APP_ALGOLIA_SEARCH_KEY) {
        throw new Error('Algolia App ID and Search-Only API Key must be set in environment variables');
    }

    return algoliasearch(process.env.VUE_APP_ALGOLIA_APP_ID, process.env.VUE_APP_ALGOLIA_SEARCH_KEY);
}